module.exports = __webpack_public_path__ + "static/media/boy_play_with_stone.963a42ac.png";